// extracted by mini-css-extract-plugin
export default {"globalTexfieldStyle":"GlobalTextField_globalTexfieldStyle__-mWF5"};